import { COMPANIES, LANGUAGES } from 'containers/pages/contacts/constants';

const makeNewContactObj = (contact, newFileId) => {
	const mapCompanyIds = contact[COMPANIES].map((company) => company.Id);
	// const mapContactTypeIds = contact[CONTACT_TYPES].map((type) => type.Id);
	const mapLanguageIds = contact[LANGUAGES].map((lanuages) => lanuages.id);

	const newContactObj = {
		Id: contact.id,
		CanEdit: contact.canEdit,
		ContactOf: contact.contactOf,
		IsEmployee: contact.isEmployee,
		FirstName: contact.firstName,
		LastName: contact.lastName,
		Customers: mapCompanyIds,
		WorkEmail: contact.emailWork,
		PersonalEmail: contact.emailPersonal,
		OtherEmail: contact.emailOther,
		// ContactTypes: mapContactTypeIds,
		ContactPosition : contact.contactPosition,
		WorkPhone: contact.phoneWork.number,
		WorkPhoneDialCode: contact.phoneWork.dialCode,
		WorkPhoneCountryCode: contact.phoneWork.countryCode,
		WorkPhoneExtension: contact.phoneWork.ext,
		CellPhone: contact.phoneMobile.number,
		CellPhoneDialCode: contact.phoneMobile.dialCode,
		CellPhoneCountryCode: contact.phoneMobile.countryCode,
		CellPhoneExtension: contact.phoneMobile.ext,
		HomePhone: contact.phoneOther.number,
		HomePhoneDialCode: contact.phoneOther.dialCode,
		HomePhoneCountryCode: contact.phoneOther.countryCode,
		HomePhoneExtension: contact.phoneOther.ext,
		Note: contact.note,
		Addresses: [
			{
				address_id: contact.addressWork.address_id,
				type: contact.addressWork.type,
				street: contact.addressWork.street + ', ' + contact.addressWork.unit,
				city: contact.addressWork.city,
				province: contact.addressWork.province,
				country: contact.addressWork.country,
				postalCode: contact.addressWork.postalCode,
				placeId: contact.addressWork.placeId,
				lat: contact.addressWork.coordinate.lat,
				lng: contact.addressWork.coordinate.lng,
			},
			{
				address_id: contact.addressHome.address_id,
				type: contact.addressHome.type,
				street: contact.addressHome.street + ', ' + contact.addressHome.unit,
				city: contact.addressHome.city,
				province: contact.addressHome.province,
				country: contact.addressHome.country,
				postalCode: contact.addressHome.postalCode,
				placeId: contact.addressHome.placeId,
				lat: contact.addressHome.coordinate.lat,
				lng: contact.addressHome.coordinate.lng,
			},
			{
				address_id: contact.addressOther.address_id,
				type: contact.addressOther.type,
				street: contact.addressOther.street + ', ' + contact.addressOther.unit,
				city: contact.addressOther.city,
				province: contact.addressOther.province,
				country: contact.addressOther.country,
				postalCode: contact.addressOther.postalCode,
				placeId: contact.addressOther.placeId,
				lat: contact.addressOther.coordinate.lat,
				lng: contact.addressOther.coordinate.lng,
			},
		],
		Languages: mapLanguageIds,
		VFileId: newFileId,
		Image: {
			file: contact.image.file,
			name: contact.image.name,
			preview: contact.image.preview,
		},
	};
	return newContactObj;
};

export default makeNewContactObj;
